import { BlogArticleFrontMatter, getParsedFileContentBySlug } from '@prishapolicy/markdown';
import { HeroBackground, slugify, useWindowWidth } from '@prishapolicy/shared/ui';
import { BlogVerticalCard, BLOG_WRITEUPS_PATH } from '@prishapolicy/w3/ui';
import fs from 'fs';
import { useState } from 'react';
import ArrowDownSLineIcon from 'remixicon-react/ArrowDownSLineIcon';
import { awardData } from '@prishapolicy/w3/assets';
import { NextSeo } from 'next-seo';
// const data: Array<AwardsInterface> = awardData;
const pressArticlesData = [
  {
    title: 'Top 44 in the Most Innovative Commercial Insurance Companies',
    description:
      'August this year, PrishaPolicy was rated in the top 44 most innovative commercial insuretech companies on the basis of Track record, Executive leadership, Market share, Innovation, ESG rating.',
    tags: ['Top in India'],
    pressArticleLink:
      'https://beststartup.in/44-india-based-commercial-insurance-companies-the-most-innovative-commercial-insurance-companies/',
    pressArticleLinkLabel: 'beststartup.in',
    imageName: 'startup-india',
  },
  {
    title: 'The Most Innovative Auto Insurance Companies',
    description: 'Out of the 4,00,000 Indian start-ups tracked, PrishaPolicy was placed',
    tags: ['Top in India'],
    pressArticleLink:
      'https://beststartup.in/81-india-based-auto-insurance-companies-the-most-innovative-auto-insurance-companies/',
    pressArticleLinkLabel: 'beststartup.in',
    imageName: 'startup-india',
  },
];
const SecondaryPressArticlesData = [
  {
    title: 'Top 44 in the Most Innovative Commercial Insurance Companies',
    description:
      'Ac, pretium in nisi, odio dolor, posuere ipsum venenatis eget facilisi neque egestas eu est aliquet odio duis vitae orci ullamcorper elit nunc, proin',
    tags: ['Top in India'],
    pressArticleLink:
      'https://beststartup.in/44-india-based-commercial-insurance-companies-the-most-innovative-commercial-insurance-companies/',
    pressArticleLinkLabel: 'beststartup.in',
    imageName: 'startup-india',
  },
  {
    title: 'The Most Innovative Auto Insurance Companies',
    description:
      'Ac, pretium in nisi, odio dolor, posuere ipsum venenatis eget facilisi neque egestas eu est aliquet odio duis vitae orci ullamcorper elit nunc, proin',
    tags: ['Top in India'],
    pressArticleLink:
      'https://beststartup.in/81-india-based-auto-insurance-companies-the-most-innovative-auto-insurance-companies/',
    pressArticleLinkLabel: 'beststartup.in',
    imageName: 'startup-india',
  },
  {
    title: 'The Most Innovative Auto Insurance Companies',
    description:
      'Ac, pretium in nisi, odio dolor, posuere ipsum venenatis eget facilisi neque egestas eu est aliquet odio duis vitae orci ullamcorper elit nunc, proin',
    tags: ['Top in India'],
    pressArticleLink:
      'https://beststartup.in/81-india-based-auto-insurance-companies-the-most-innovative-auto-insurance-companies/',
    pressArticleLinkLabel: 'beststartup.in',
    imageName: 'startup-india',
  },
];

export const PressAndAwards = () => {
  const { isLg } = useWindowWidth();
  const [seeAll, setSeeAll] = useState(false);
  return (
    <>
      <NextSeo
        title="Press and Awards | PrishaPolicy"
        description="Press and Awards - PrishaPolicy , Proving why PrishaPolicy is top choice for reliable insurance services "
      />
      <div>
        <HeroBackground backgroundColor="teal-300">
          <div className="container relative lg:pb-96">
            <div className="text-center ">
              <h3 className="lg:text-title-5 text-title-6 font-medium">About Us</h3>
              <h1 className="mt-4 font-bold" style={{ fontSize: isLg ? 60 : 40 }}>
                Awards & Mentions
              </h1>
              <h3 className=" lg:text-title-6 text-body-1 mt-3">Insurance needs Trust.</h3>
            </div>
            {isLg && (
              <div className=" mt-18 absolute flex grid-cols-2  flex-col gap-6 lg:grid">
                {pressArticlesData.map((article, idx) => {
                  return <BlogVerticalCard key={idx} size="large" blog={article} />;
                })}
              </div>
            )}
          </div>
        </HeroBackground>

        <div className=" mt-15  bg-red-200 p-5 lg:mt-80 ">
          <h2 className={`heading-2 mt-12 mb-5 text-center text-red-900`}>Awards</h2>
          <div className="container grid grid-cols-2 gap-5 lg:grid-cols-5">
            {(seeAll ? awardData : awardData.slice(0, isLg ? 10 : 4)).map((award) => (
              <AwardCard
                key={award.awardName}
                awardName={award.awardName}
                date={award.date}
                awardNumber={award.awardNumber}
              />
            ))}
          </div>
          {!seeAll && (
            <div className="text-primary  text-body-1 my-9 flex w-full justify-center font-medium underline-offset-4">
              <button onClick={() => setSeeAll(true)} className="flex  underline ">
                See all <ArrowDownSLineIcon />
              </button>
            </div>
          )}
        </div>
        <BlogsCarousel blogs={SecondaryPressArticlesData} />
      </div>
    </>
  );
};
const BlogsCarousel = ({ blogs }: { blogs: BlogArticleFrontMatter[] }) => {
  return (
    <div className="my-11 bg-teal-200 p-5">
      <h2 className={`heading-2 mt-12 mb-5 text-center text-teal-900`}>Press</h2>
      <div className="container flex gap-x-5">
        <div className={`mb-16 flex gap-x-5 overflow-x-auto lg:overflow-hidden`}>
          {blogs.map((blog, idx) => {
            return <BlogVerticalCard blog={blog} key={idx} />;
          })}
        </div>
      </div>
    </div>
  );
};

const AwardCard = ({ date, awardName, awardNumber }) => {
  return (
    <div
      style={{ backgroundImage: `url(./bg-vector.png)` }}
      className="text-grey-700 text-body-3 flex min-w-[80%] flex-col items-center justify-evenly gap-y-4 bg-white px-6 py-5 font-bold lg:w-full"
    >
      <h1>{date}</h1>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`/award-assets/${awardNumber ? slugify(awardName) + '-' + awardNumber : slugify(awardName)}.png`}
        className="h-[64px] lg:h-[100px]"
        alt="Award Image"
      />
      <div className="text-center">
        <h1 className="mb-1">Winner</h1>
        <h1 className="text-title-7 text-black ">{awardName}</h1>
      </div>
    </div>
  );
};

export const getStaticProps = () => {
  const blogsDir = fs.readdirSync(BLOG_WRITEUPS_PATH);
  const articlesData = blogsDir.map((blogFile) => {
    const blogSlug = blogFile.replace(/\.mdx?$/, '');
    const mdContent = getParsedFileContentBySlug<BlogArticleFrontMatter>(blogSlug, BLOG_WRITEUPS_PATH);

    return { ...mdContent.frontMatter, slug: blogSlug };
  });

  return { props: { articlesData } };
};

export default PressAndAwards;
